// extracted by mini-css-extract-plugin
export var userPageStructure = "user-page-structure_LjX1501tdMChVB6tYDIU";
export var userPageStructureMain = "user-page-structure__main_aEMcAHVrRwKoMQq8BUAs";
export var userPageStructureSidebar = "user-page-structure__sidebar_YkTioecXb9P756iLzG8c";